/* eslint-disable no-console */

/**
 * @file
 * Old AMD key: `ac/navigator/utils`
 */

import uri from 'uritemplate';
import { canSpaTransition, getContainerApi, getNavigationApi, isInIframe } from '../spa-context';
import type { NavigatorContext } from './types';

let isEnabled = false;

export const enableApi = () => {
	isEnabled = true;
};

export const disableApi = () => {
	isEnabled = false;
};

export const isApiEnabled = () => isEnabled;

export const buildUrl = (urlTemplate: string, context: NavigatorContext) => {
	let finalUrlTemplate = urlTemplate;

	if (urlTemplate[0] !== '/') {
		finalUrlTemplate = `/${urlTemplate}`;
	}

	return uri.parse(finalUrlTemplate).expand(context);
};

export const goToUrl = (url: string) => {
	const goTo = function () {
		window.location.href = url;
	};

	if (isInIframe()) {
		const containerApi = getContainerApi();
		containerApi && containerApi.navigate && containerApi.navigate(url, goTo);
	} else if (canSpaTransition()) {
		const navApi = getNavigationApi();
		navApi && navApi.navigate && navApi.navigate(url);
	} else {
		goTo();
	}
};

export const hasContext = (context: NavigatorContext, fieldName: string) => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
	if (!(context as any)[fieldName]) {
		console.error(`Missing ${fieldName} in navigator context`);
		return false;
	}
	return true;
};

export const appendQueryParam = (url: string, key: string, value: string) =>
	`${url + (url.indexOf('?') > -1 ? '&' : '?') + key}=${encodeURIComponent(value)}`;

export const getTopmostSameOriginWindow = (win: Window) => {
	function satisfiesSameOrigin(w: Window) {
		try {
			// Accessing location.href from a window on another origin will throw an exception.
			if (w.location.href == null) {
				return false;
			}
		} catch (e) {
			return false;
		}
		return true;
	}

	function isTopMostWindow(w: Window) {
		return w === w.parent;
	}

	let topWindow = win;

	while (!isTopMostWindow(topWindow) && satisfiesSameOrigin(topWindow.parent)) {
		topWindow = topWindow.parent;
	}

	return topWindow;
};
